import React from 'react'

const MyAccountDataRow = ({ label, value, variant = undefined, info = undefined }) => {
  return (
    <div>
      <div className={'myaccount-data-row' + (variant ? ' myaccount-data-row--' + variant : '')}>
        {!!label && <p className="myaccount-data-row__label">{label}</p>}
        <p className="myaccount-data-row__value">{value}</p>
      </div>
      {!!info && (
        <div className="myaccount-data-row__info" dangerouslySetInnerHTML={{ __html: info }} />
      )}
    </div>
  )
}

export default MyAccountDataRow
